const DEV_PROXY = `http://localhost:8083`
export const BASE_URL = process.env.NODE_ENV === `development` ? DEV_PROXY : ``
export const USE_LOCAL_DEVELOPMENT = process.env.USE_LOCAL_DEVELOPMENT === `true`
